export default __webpack_public_path__ + "static/media/CHENNAI-5.6f01d0a1.webp";